import { ReactNode, memo } from 'react';
import { FormProps } from 'antd';

import { HeaderStepperOptions, FormType } from '@Components/MainForm/types';
import { User, RequisitionInfo } from 'types';
import { FooterActions } from '@Enum/index';
import { Balance } from '@Types/api/form/leaveRequest/Balance';

import { ViewResolver } from '..';
import MainFormMobile from './mobile/MainFormMobile';
import MainFormDekstop from './desktop/MainFormDekstop';

interface MainFormProps {
  userInfo: User;
  requisitionInfo: RequisitionInfo;
  formType: FormType;
  selectedUser?: User;
  disabledNextStep?: boolean;
  disabledSaveForm?: boolean;
  descriptionAlert?: JSX.Element;
  showSelectEmployee?: boolean;
  showLeaveBalance?: boolean;
  showMRsection?: boolean;
  layout?: FormProps['layout'];
  children?: ReactNode;
  className?: string;
  handleSubmit?: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
  handleSearchEmpByNumber?: (empNumber?: string) => void;
  handleApplySelectedUser?: () => void;
  onFooterAction: (action: FooterActions, payload?: string) => void;
  showExtraUserFields?: boolean;
  balance?: Balance;
  headerStepperOptions?: HeaderStepperOptions;
  requestHeaderStep?: boolean;
  approveBtnName?: string;
}

const MainForm: React.FC<MainFormProps> = (props) => {
  return (
    <ViewResolver
      desktop={<MainFormDekstop {...props} />}
      mobile={<MainFormMobile {...props} />}
    />
  );
};

export default memo(MainForm);
